import * as service from "./service";
import to from "await-to-js";
import _ from 'lodash';

export const state = {
  user: null,
  menuAdm: false,
  empresa: null,
  token: null
};

export const getters = {
  user: state => {
    if (state.user) {
      return state.user;
    }
    let store = JSON.parse(window.localStorage.getItem("user"));
    if (!store) return null;
    
    // eslint-disable-next-line
    console.log("STORE", store);

    let token = store.token;
    if (!token) return null;

    let result = _.cloneDeep(store.user);
    result.token = store.token;
    return store.user;
  },
  token: (state) => {
    if (state.token) {
      return state.token;
    }

    let store = JSON.parse(window.localStorage.getItem("user"));
    if (!store) return null;
    // eslint-disable-next-line
    console.log("STORE", store);

    return store.token;
  },
  menuAdm: state => state.menuAdm,
  empresa: state => {
    if (state.empresa) return state.empresa;

    let store = JSON.parse(window.localStorage.getItem("juridica"));
    if (store) {
      return store
    }
    return null;
  },
  isAdministrador: state => {
    if (!getters.user(state)) return false;
    return getters.user(state).role === 'Administrador'
  },
  isVendedor: state => {
    if (!getters.user(state)) return false;
    return getters.user(state).role === 'Vendedor'
  },
  isVendedorMaster: state => {
    if (!getters.user(state)) return false;
    return getters.user(state).role === 'VendedorMaster'
  }
};

export const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  setEmpresa (state, payload) {
    state.empresa = payload
  },
  setToken (state, payload) {
    state.token = payload;
  }
};

export const actions = {
  setUser ({commit}, payload) {
    commit('setUser', payload)
  },
  setEmpresa ({commit}, payload) {
    if (payload) {
      window.localStorage.setItem('juridica', window.JSON.stringify(payload))
    } else {
      window.localStorage.removeItem('juridica');
    }
    commit('setEmpresa', payload)
  },
  setToken({commit}, payload) {
    commit('setToken', payload);
  },
  async login(context, credentials) {
    context.dispatch("setLoading", true);

    const [
      error = { response: { data: null } },
      response = { data: null }
    ] = await to(service.login(credentials));
    if (error) {
      context.dispatch("setLoading", false);
      return Promise.reject(error.response.data);
    }

    window.localStorage.setItem('user', window.JSON.stringify(response.data))

    const user = response.data.user;
    context.dispatch('setUser', user);
    context.dispatch('setToken', user.token);

    context.dispatch('setEmpresa', response.data.user.juridica);
    
    context.dispatch('setLoading', false);

    return response.data;
  },

  logout ({dispatch}) {
    window.localStorage.removeItem('user')
    dispatch('setUser')
    dispatch('setEmpresa')
  }
};
